var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef } from 'react';
export default (function () {
    var isMounted = useRef(true); // A ref to track if component is mounted
    useEffect(function () {
        return function () {
            // Cleanup function to set isMounted to false when component unmounts
            isMounted.current = false;
        };
    }, []);
    var waitFor = function (milliseconds) { return new Promise(function (resolve) { return setTimeout(resolve, milliseconds); }); };
    var retry = function (promise, onRetry, maxRetries, interval, shouldRetry) {
        if (interval === void 0) { interval = 2; }
        var retryWithBackoff = function (retries) { return __awaiter(void 0, void 0, void 0, function () {
            var timeToWait, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!(retries > 0)) return [3 /*break*/, 2];
                        timeToWait = interval * 1000;
                        console.log("waiting for ".concat(timeToWait, "ms..."));
                        return [4 /*yield*/, waitFor(timeToWait)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!isMounted.current)
                            return [2 /*return*/]; // Check if component is unmounted
                        return [4 /*yield*/, promise()];
                    case 3: // Check if component is unmounted
                    return [2 /*return*/, _a.sent()];
                    case 4:
                        e_1 = _a.sent();
                        if (!isMounted.current)
                            return [2 /*return*/]; // Check if component is unmounted
                        if (retries < maxRetries) {
                            onRetry();
                            return [2 /*return*/, retryWithBackoff(retries + 1)];
                        }
                        else {
                            console.warn('Max retries reached. Bubbling the error up');
                            throw e_1;
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return retryWithBackoff(0);
    };
    return {
        retry: retry
    };
});
